module.exports = __webpack_public_path__ + "static/media/brand03.9177febf.png";